import { ModuleType } from 'global-services/constants/OhsObject';

import { getConfigValue, setPermissions } from '../OhsConfigServices';
import { OhsModuleConfig } from '../OhsModuleConfig';
import OhsModulePermissions from '../OhsModulePermissions';

interface EnabledSchedules {
  EXPORT_BUILDER: boolean;
  CORRESPONDENCE_EXCHANGE_REPLICATOR: boolean;
  CORRESPONDENCE_EXCHANGE_RESENDER: boolean;
}

const DEFAULT_ENABLED_SCHEDULES: EnabledSchedules = {
  EXPORT_BUILDER: false,
  CORRESPONDENCE_EXCHANGE_REPLICATOR: false,
  CORRESPONDENCE_EXCHANGE_RESENDER: false,
};

const ENABLED_SCHEDULES_KEYS = Object.keys(DEFAULT_ENABLED_SCHEDULES) as Array<
  keyof EnabledSchedules
>;

function scheduleConfig(configValue: string | string[]): EnabledSchedules {
  const enabledSchedules = { ...DEFAULT_ENABLED_SCHEDULES };

  if (configValue === '*') {
    ENABLED_SCHEDULES_KEYS.forEach((key) => {
      enabledSchedules[key] = true;
    });
    return enabledSchedules;
  }

  if (Array.isArray(configValue)) {
    configValue.forEach((key) => {
      if (ENABLED_SCHEDULES_KEYS.includes(key as keyof EnabledSchedules)) {
        enabledSchedules[key as keyof EnabledSchedules] = true;
      }
    });
  }

  return enabledSchedules;
}

class OhSchedulerConfig implements OhsModuleConfig {
  TITLE: string;

  PERMISSIONS: OhsModulePermissions;

  MORPH_PERMISSIONS: OhsModulePermissions;

  ENABLED_SCHEDULES: EnabledSchedules;

  TYPE = ModuleType.Scheduler;

  constructor(config: any) {
    this.TITLE = getConfigValue(config, 'TITLE');
    this.ENABLED_SCHEDULES = scheduleConfig(
      getConfigValue(config, 'ENABLED_SCHEDULES') as string | string[]
    );
    this.PERMISSIONS = new OhsModulePermissions(false);
    this.MORPH_PERMISSIONS = new OhsModulePermissions(false);
    setPermissions(this.PERMISSIONS, getConfigValue(config, 'PERMISSIONS'));
    setPermissions(this.MORPH_PERMISSIONS, getConfigValue(config, 'MORPH_PERMISSIONS'));
  }
}

export default OhSchedulerConfig;
